import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchSupervisorsData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/api";
import { ISupervisorsData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/Forms/OrganizationStructureForm.models";

const useFetchSupervisorsData = (
  companyId: string,
  employeeId: string,
  query: string
) => {
  let filters: string | null = null;

  if (query !== "") {
    const [firstPhrase, secondPhrase] = query.split(" ");

    if (secondPhrase) {
      filters = `(firstName=like=*${firstPhrase}*;lastName=like=*${secondPhrase}*),(firstName=like=*${secondPhrase}*;lastName=like=*${firstPhrase}*)`;
    } else {
      filters = `(firstName=like=*${firstPhrase}*,lastName=like=*${firstPhrase}*)`;
    }
  }

  return useInfiniteQuery<ISupervisorsData, Error>({
    queryKey: [
      "fetch-available-supervisors-data",
      companyId,
      employeeId,
      query,
    ],
    queryFn: async ({ pageParam, signal }) => {
      const data = await fetchSupervisorsData(companyId, employeeId, {
        signal,
        nextCursor: pageParam,
        query: filters,
      });
      return data;
    },
    enabled: !!companyId && !!employeeId,
    initialPageParam: null,
    getNextPageParam: (lastPage) => lastPage.nextCursor || null,
    placeholderData: (previousData) =>
      previousData ?? { pages: [], pageParams: [] },
  });
};

export default useFetchSupervisorsData;
